import { Typography } from "@mui/joy";
import { Link } from "react-router-dom";

export function BlueLink({ children, to, ...props }) {
    let target = null;
    let rel = null;
    if (props?.target) {
        target = props.target ?? null;
        delete props.target;
    }
    if (props?.rel) {
        rel = props.rel ?? null;
        delete props.rel;
    }
    return <Link to={to} style={{ textDecoration: 'none' }} {...{ target, rel }}>
        <Typography color='primary' {...props} >{children}</Typography>
    </Link>
}